export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BaseTable.vue?vue&type=template&id=303f3f38"


//////////////////
// WEBPACK FOOTER
// ./src/components/Tables/BaseTable.vue?vue&type=template&id=303f3f38
// module id = 1428
// module chunks = 31